import React, { Component } from 'react'
import {
  Button,
  Card
} from 'antd'
import { withTranslation } from 'react-i18next'

class Registrations extends Component {
  handlePaidExport = async () => {
    this.props.onPaidExport()
  }
  handleExport = async () => {
    this.props.onExport()
  }
  handleDateExport = async () => {
    this.props.onDateExport()
  }

  render () {
    const { t } = this.props
    return (
      <div className='eventDownloadBox no-print'>
        <Card
          title={t('download.registration.title')}
          size="small"
          style={{marginBottom: 10}}
          key='Registrations'
        >
          <div style={{marginBottom: '9px'}}>
            <Button
              onClick={this.handlePaidExport}
              icon="export"
              loading={this.props.exporting}
            >
              {t('download.download')}
            </Button>{t('download.runner.success')}
          </div>
          <div style={{marginBottom: '9px'}}>
            <Button
              onClick={this.handleDateExport}
              icon="export"
              loading={this.props.exporting}
            >
            {t('download.download')}
            </Button>{t('download.runner.date')}
          </div>
          <Button
            onClick={this.handleExport}
            icon="export"
            loading={this.props.exporting}
          >
            {t('download.download')}
          </Button>{t('download.runner.all')}
        </Card>
      </div>
    )
  }
}

export default withTranslation() (Registrations)
